export default "__VITE_ASSET__5O75R3bw__"